import template from './sw-cms-block-preview-sidebar-filter.html.twig';
import './sw-cms-block-preview-sidebar-filter.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
